<script>
import { Input, Button, Checkbox, message } from 'ant-design-vue'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getAction } from '@/command/netTool'
import { setCookie } from '@/utils/cookie'

export default {
  name: 'login-new',
  data() {
    return {
      username: '',
      password: '',
      remember: false,
      loading: false
    }
  },
  created() {},
  mounted() {
    localStorage.removeItem('userInfos')
    localStorage.removeItem('tenantArr')
    localStorage.removeItem('appCode')
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    loginSuccess(userData) {
      let { user_info, access_token, token_type } = userData
      localStorage.setItem('userInfos', JSON.stringify(user_info))
      setCookie('access_token', `${access_token}`, 5)
      getAction('/farmTenant/myList').then(res => {
        if (res.code == 200) {
          let arr = res.data.filter(s => s)
          if (arr.length > 0) {
            localStorage.setItem('tenantArr', JSON.stringify(arr))
            localStorage.setItem('appCode', arr[0]['tenantId'])
            localStorage.setItem('logo', arr[0].sysIcon || '')
            this.setJump()
          } else {
            this.$message.error('没有租户不可登入！')
            return
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    setJump() {
      if (process.env.NODE_ENV === 'development') {
        this.$router.push('/')
      } else {
        getAction('/admin/menu/userTree?sysCode=sznc', {}, '/bpi').then(e => {
          if (e.data) {
            this.$router.push({
              path: `/${e['data'][0]['path'].replace('/', '')}`
            })
            setTimeout(() => {
              this.$notification.success({
                message: '欢迎',
                description: `${timeFix()}，欢迎回来`
              })
            }, 500)
          } else {
            this.$message.warning('您暂无权限，不可进入！')
          }
        })
      }
    },
    onLogin() {
      if (this.username === '' || this.password === '') {
        this.$message.error('请输入账号/密码')
        return
      }
      this.loading = true
      this.Login({
        username: this.username,
        password: this.password
      })
        .then(result => {
          this.loginSuccess(result)
        })
        .catch(err => {
          getAction(
            '/admin/account/lock/queryLockInfo',
            { username: this.username },
            '/bpi'
          ).then(res => {
            if (res.code === 200) {
              let { data } = res
              if (data.lockStatus == '0') {
                this.$message.error(
                  `账号密码错误，还有${data.errorTimes}次账号将锁定！`
                )
              } else if (data.lockStatus == '1') {
                this.$message.error(
                  `账号已锁定，请${data.lockTimes}分钟后充重试！`
                )
              } else {
                this.$message.error(err.msg)
              }
            } else {
              this.$message.error('登录失败，请重新登入！')
            }
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  render() {
    return (
      <div class="login-main">
        <div class="left-content"></div>
        <div class="right-content">
          <div class="login-form">
            <div class="form-title">用户登录</div>
            <div class="form-item">
              <Input
                v-model={this.username}
                placeholder="请输入账号"
                prefix={<a-icon type="user" />}
                size="large"
              />
            </div>
            <div class="form-item">
              <Input
                v-model={this.password}
                type="password"
                placeholder="请输入密码"
                prefix={<a-icon type="lock" />}
                size="large"
              />
            </div>
            <div class="form-item remember">
              <Checkbox v-model={this.remember}>记住密码</Checkbox>
            </div>
            <div class="form-item">
              <Button
                type="primary"
                size="large"
                block
                loading={this.loading}
                onClick={this.onLogin}
              >
                登录
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
</script>

<style lang="less" scoped>
.login-main {
  display: flex;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%);
  overflow: hidden;
  background-image: url('../../assets/View/ctbl-login-bg.png');

  @media (max-width: 768px) {
    flex-direction: column;
  }

  .left-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;

    @media (max-width: 768px) {
      flex: none;
      height: 40vh;
      padding: 20px;
    }

    .system-title {
      font-size: 28px;
      font-weight: bold;
      color: #333;
      margin-bottom: 40px;

      @media (max-width: 768px) {
        font-size: 24px;
        margin-bottom: 20px;
      }
    }

    .illustration {
      width: 100%;
      max-width: 600px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .right-content {
    flex: none;
    width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    margin-right: 180px;

    @media (max-width: 768px) {
      width: 100%;
      flex: 1;
      padding: 20px;
    }

    .login-form {
      width: 100%;
      max-width: 320px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      padding: 30px;

      @media (max-width: 768px) {
        padding: 20px;
      }

      .form-title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        text-align: center;
        margin-bottom: 30px;
      }

      .form-item {
        margin-bottom: 20px;

        &.remember {
          margin-bottom: 30px;

          :deep(.ant-checkbox-group) {
            display: flex;
            justify-content: flex-start;
          }
        }

        :deep(.ant-input-affix-wrapper) {
          border-radius: 8px;
          height: 48px;

          .ant-input {
            font-size: 14px;
          }
        }

        :deep(.ant-btn) {
          border-radius: 8px;
          height: 48px;
          font-size: 16px;
          font-weight: 500;
          background: #1890ff;
          border-color: #1890ff;

          &:hover {
            background: #40a9ff;
            border-color: #40a9ff;
          }

          &:active {
            background: #096dd9;
            border-color: #096dd9;
          }
        }
      }
    }
  }
}
</style>
